export default "__VITE_ASSET__CoaCe$ol__"